import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router/dist'
import CO2Service, { FarmerCo2Type } from '~/api/services/co2'
import Dialog from '~/components/Dialog'
import notify from '~/components/Notify'
import { Nullable } from '~/types'
import { handleErrors } from '~/utils/helpers'

interface Props {
  farmersData: Nullable<FarmerCo2Type>
  handleClose: (submited?: boolean) => void
}

const ResetModal: React.FC<Props> = ({ farmersData, handleClose }) => {
  const { t } = useTranslation()
  const { id } = useParams()

  const [isLoading, setIsLoading] = useState(false)

  async function handleResetFarmerCo2Slot() {
    setIsLoading(true)
    try {
      await CO2Service.resetFarmersCo2Slot(id, farmersData.id)
      notify('Datenerhebung wurde erfolgreich zurückgesetzt.', 'success')
      handleClose(true)
    } catch (error) {
      handleErrors(error)
    }
    setIsLoading(false)
  }

  return <Dialog
      open={Boolean(farmersData)}
      isLoading={isLoading}
      handleClose={() => handleClose()}
      textContent={<div dangerouslySetInnerHTML={{ __html: ` Möchten Sie wirklich die Datenerhebung für <b>${farmersData?.companyName || ''}</b> zurücksetzen?` }}/>}
      textHeader={'Datenerhebung zurücksetzen'}
      textClose={t('Cancel')}
      textSubmit={t('Reset')}
      handleSubmit={() => handleResetFarmerCo2Slot()}
      type={'abort'}
  />
}
export default ResetModal